import React from "react";

const Footer = () => {
    return (
      <footer className="py-6 text-gray-300 bg-gray-800">
        <div className="container px-4 mx-auto">
          <div className="grid grid-cols-1 gap-6 items-center md:grid-cols-3">
            {/* Copyright Section */}
            <div className="text-center md:text-left">
              <span className="text-sm">&copy; 2024 OSIS SMA Negeri 2 Amlapura</span>
            </div>
            <div className="flex justify-center space-x-4">
              {/* <a href="#" className="text-gray-300 hover:text-white">
                <i className="text-xl fab fa-x-twitter"></i>
              </a> */}
              <a href="https://web.facebook.com/sman2amlapura/?ref=bookmarks" className="text-gray-300 hover:text-white">
                <i className="text-xl fab fa-facebook"></i>
              </a>
              <a href="https://www.instagram.com/osismpk_smandapura/?hl=id" className="text-gray-300 hover:text-white">
                <i className="text-xl fab fa-instagram"></i>
              </a>
              <a href="https://www.youtube.com/channel/UCWMCWKD6GJ4wuS1S8lcdg9A" className="text-gray-300 hover:text-white">
                <i className="text-xl fab fa-youtube"></i>
              </a>
            </div>
            <div className="text-center md:text-right">
              <ul className="space-y-2">
                <li>
                  <a href="https://maps.app.goo.gl/varBPu259huZxAUYA" className="flex items-center space-x-2 hover:text-white">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>Alamat</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center space-x-2 hover:text-white">
                    <i className="fas fa-envelope"></i>
                    <span>Email</span>
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center space-x-2 hover:text-white">
                    <i className="fas fa-phone"></i>
                    <span>Phone</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  };

  export default Footer;
